import { Button, Card } from '@driftt/tide-core-legacy'
import { Link } from 'react-router'
import './style.styl'

import { CUSTOMER_API } from 'constants/ResourcesConstants'

const LEANDATA_INTEGRATION_SWITCH = 'leandata-integration-switch'

const SALESFORCE_ATTRIBUTE_MAPPINGS_PATH = '/settings/salesforce/mapping/attributes'
const SALESFORCE_TEAMMATE_MAPPINGS_PATH = '/settings/salesforce/mapping/users'
const GLOBAL_ROUTING_RULES_PATH = '/settings/rules'
const PLAYBOOKS_PATH = '/playbooks'

const makeConnectButtonPressConfig = (enabled, successCallback) => ({
  url: `${CUSTOMER_API}/integrations/leandata/toggles`,
  method: 'patch',
  data: {
    enabled,
  },
  successMessage: `Successfully turned off the LeanData integration`,
  errorMessage: `Something went wrong and we couldn’t turn off the LeanData integration`,
  clickId: LEANDATA_INTEGRATION_SWITCH,
  successCallback,
})

const LeanDataCard = ({ header, message, linkText, linkTo }) => (
  <div className="leandata-card">
    <div className="leandata-card-header">
      {header}
    </div>
    <p>{message}</p>
    <Link className={"leandata-card-link"} to={linkTo}>{linkText}</Link>
  </div>
)

const LeanDataConnected = ({ asyncButtonPress, togglePending, integrationsFetchPending, fetchIntegrationStates }) => (
  <div className="leandata-connected-view-container">
    <div className="leandata-connected-view-header">You’re all set to start using LeanData for conversation routing!</div>
    <div className="leandata-connected-cards-container">
      <LeanDataCard 
        header={"Create a conversation routing rule"} 
        message={"Use LeanData in a conversation routing rule to connect site visitors with the right teammate."} 
        linkText={"View conversation routing rules"} 
        linkTo={GLOBAL_ROUTING_RULES_PATH} />
      <LeanDataCard 
        header={"Route teammates in bot playbooks"} 
        message={"Use LeanData to route the conversation at specific points in a bot conversation."} 
        linkText={"View all playbooks "} 
        linkTo={PLAYBOOKS_PATH} />
    </div>
    <div className="leandata-connected-note-container">
      <p><b>Note: </b>We recommend checking that your <span><Link to={SALESFORCE_ATTRIBUTE_MAPPINGS_PATH}>attribute mappings</Link></span> between Drift and Salesforce are set up correctly, and that your <span><Link to={SALESFORCE_TEAMMATE_MAPPINGS_PATH}>teammates</Link></span> are in both Drift and Salesforce.</p>
    </div>
    <div className="leandata-connected-disconnect-container">
    <Button type="secondary" loading={togglePending || integrationsFetchPending} onClick={() => asyncButtonPress(makeConnectButtonPressConfig(false, fetchIntegrationStates))}>Disconnect LeanData</Button>
    </div>
  </div>
)

export default LeanDataConnected



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/LeanData/components/LeanDataConnected/index.js